import './FooterLink.scss';

export function FooterLink({ to, text }) {
  return (
    <a className='footer-link' href={to}>{text}</a>
  );
}
